// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"e_Bv","scoreNumber":"e_Cv","scoreStars":"e_Dv","badge":"e_Ev","badgeImage":"e_Fv"};